import React, { useState, useEffect, useRef } from "react";
import { baseUrl } from '../../shared.js';
import { StatusChip } from '../../components/ui';
import Box from '@mui/material/Box';
import '../App.css';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from "@mui/material/MenuItem";
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SignatureCanvas from 'react-signature-canvas';

function UpdateBookingStatus({ bookingItem, onSuccess }) {
  const [origBooking] = useState(bookingItem);
  const [updateBooking, setUpdateBooking] = useState(bookingItem);
  const [statusList, setStatusList] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [signature, setSignature] = useState(null);
  const sigPad = useRef(null);
  const [responseOpen, setResponseOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    lookupBooking();
  }, []);

  function lookupBooking() {
    const url = baseUrl + 'status/list/';
    fetch(url, {
      method: 'GET',
      headers: {
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken')
      }
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.status === 200) setStatusList(json.data);
        else setStatusList([]);
      })
      .catch((err) => console.log(err.message));
  }

const onDrop = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setIsDragging(false);

  const files = Array.from(e.dataTransfer.files);

  if (!files.length) return;

  handleFiles(files);
};

const handleFiles = (files) => {
  const imageFiles = files.filter(file =>
    file.type.startsWith("image/")
  );

  const previews = imageFiles.map(file =>
    URL.createObjectURL(file)
  );

  setPhotos(prev => [...prev, ...previews]);
};

  async function updateBookingAndAssets(origBooking, updateBooking, photos = [], signature = null) {
  try {
    // 🧠 Compare current vs original booking (deep comparison)
    const ignoredKeys = ['id', 'createdAt', 'updatedAt'];
    const hasBookingChanges = Object.keys(updateBooking).some((key) => {
      if (ignoredKeys.includes(key)) return false;
      const oldValue = bookingItem[key];
      const newValue = updateBooking[key];

      // Treat undefined/null/empty string as equivalent
      const normalize = (v) => (v === undefined || v === null ? '' : v);
      return normalize(oldValue) !== normalize(newValue);
    });

    // 🖼️ Detect new photos or signatures
    const hasNewPhotos = photos.length > 0;
    const hasNewSignature = !!signature;

    // 💤 Nothing changed
    if (!hasBookingChanges && !hasNewPhotos && !hasNewSignature) {
      console.log('No updates detected. Skipping.');
      setMessage('No changes to save.');
      setResponseOpen(true);
      return;
    }

    const fullUpdateUrl = baseUrl + 'hire/updateFull';

    // 🖼️ Resize all images before upload
    let processedPhotos = [];
    if (hasNewPhotos) {
      processedPhotos = await Promise.all(
        photos.map(async (photo) => await resizeImage(photo, 600, 600))
      );
    }

    // 🏁 Prepare flags for backend
    const flags = {
      bookingUpdated: hasBookingChanges,
      photosAdded: hasNewPhotos,
      signatureAdded: hasNewSignature,
    };

    const body = {
      updateBooking,
      photos: processedPhotos,
      signature: signature || null,
      flags,
    };

    console.log("🔍 Sending payload with flags:", flags);

    const res = await fetch(fullUpdateUrl, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage.getItem('username'),
        'bToken': localStorage.getItem('bToken'),
      },
      body: JSON.stringify(body),
    }).then((r) => r.json());

    if (res.status === 200) {
      setMessage(res.message || 'Booking updated successfully.');
    } else {
      setMessage(res.message || 'Booking update failed.');
    }

    setResponseOpen(true);
  } catch (err) {
    console.error('❌ Error updating booking:', err);
    setMessage('Unexpected error updating booking.');
    setResponseOpen(true);
  }
}



  // async function updateBookingStatus(e) {
  //   e.preventDefault();

  //   // 1️⃣ Update the booking itself
  //   const bookingUrl = baseUrl + 'hire/edit';
  //   const bookingRes = await fetch(bookingUrl, {
  //     method: 'PATCH',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'username': localStorage.getItem('username'),
  //       'bToken': localStorage.getItem('bToken')
  //     },
  //     body: JSON.stringify(updateBooking),
  //   }).then((r) => r.json());

  //   if (bookingRes.status !== 200) {
  //     setMessage(bookingRes.message || 'Booking update failed');
  //     setResponseOpen(true);
  //     return;
  //   }

    function resizeImage(base64Str, maxWidth = 800, maxHeight = 800) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let { width, height } = img;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.5)); // smaller upload
    };
  });
}

// // 2️⃣ Upload photos (if any)
// if (photos.length > 0) {
    
//   const photoUrl = baseUrl + 'booking/photos/add';

//   for (const photo of photos) {
//     try {
//       // Resize/compress photo before upload
//       const resizedPhoto = await resizeImage(photo, 600, 600); // You can tweak max dimensions

//       await fetch(photoUrl, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'username': localStorage.getItem('username'),
//           'bToken': localStorage.getItem('bToken')
//         },
//         body: JSON.stringify({
//           bookingId: updateBooking.id,
//           base64Image: resizedPhoto,
//           statusId: updateBooking.statusId,
//           status: updateBooking.status
//         }),
//       });
//     } catch (err) {
//       console.error('Error uploading photo:', err);
//     }
//   }
// }

//     // 3️⃣ Upload signature (if any)
//     if (signature) {
//       const sigUrl = baseUrl + 'booking/signature/add';
//       await fetch(sigUrl, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'username': localStorage.getItem('username'),
//           'bToken': localStorage.getItem('bToken')
//         },
//         body: JSON.stringify({
//           bookingId: updateBooking.id,
//           base64Signature: signature,
//           statusId: updateBooking.statusId,
//           status: updateBooking.status
//         }),
//       });
//     }

//     setMessage('Booking, photos, and signature updated successfully!');
//     setResponseOpen(true);
//   }

  // Handle photo uploads
  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotos((prev) => [...prev, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleClearSignature = () => {
  if (sigPad.current) sigPad.current.clear();
  setSignature(null);
  };

  const handleSaveSignature = () => {
  if (sigPad.current && !sigPad.current.isEmpty()) {
    const dataURL = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
    setSignature(dataURL); // store in state to send to backend
    }
  };

  const handleResponseClose = () => {
    setResponseOpen(false);
    onSuccess();
  };

  return (
    <div>
      {/* Response Dialog */}
      <Dialog
        open={responseOpen}
        onClose={handleResponseClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle>Booking Update</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResponseClose}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* Current status */}
      {updateBooking?.status && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <Box sx={{ fontSize: 12, color: 'var(--muted)' }}>Current:</Box>
          <StatusChip domain="booking" value={updateBooking.status} dot size="md" />
        </Box>
      )}

      {/* Status Selector */}
      <Select
        native
        fullWidth
        value={updateBooking?.statusId || ""}
        onChange={(e) => {
          const selectedId = e.target.value;
          const selectedStatus = statusList.find(
            (s) => s.id.toString() === selectedId.toString()
          );
          setUpdateBooking({
            ...updateBooking,
            statusId: selectedId,
            status: selectedStatus?.status || "",
          });
        }}
        inputProps={{
          id: "bookingStatusTitle",
        }}
      >
        <option value="" disabled>
          {updateBooking?.status
            ? `Current: ${updateBooking.status}`
            : "Select status"}
        </option>
        {statusList?.map((status) => (
          <option key={status.id} value={status.id}>
            {status.status}
          </option>
        ))}
      </Select>

      <br /><br />

      {/* Photo Upload */}

      <div 
        className={`drop-zone ${isDragging ? 'dragging' : ''}`}
        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={onDrop}
        style={{ border: isDragging ? '2px dashed #007bff' : '2px dashed #ccc', padding: '20px' }}
      >
        <label>Upload Photos (optional)</label>
         <>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handlePhotoUpload}
              id="photo-input"
            />
            <p>Drag and drop or click to select from gallery/files</p>
          </>
      </div>
      <div>
        {photos.map((p, i) => (
          <img key={i} src={p} alt="preview" style={{ width: 100, margin: 4 }} />
        ))}
      </div>

      <br />

      {/* Signature Capture */}
      {!signature && (
      <div>
      <h4>Signature (optional)</h4>
      <SignatureCanvas
        penColor="black"
        canvasProps={{ width: 300, height: 150, className: 'sigCanvas' }}
        ref={sigPad}
      />
      <div>
        <Button onClick={handleClearSignature}>Clear</Button>
        <Button onClick={handleSaveSignature}>Save Signature</Button>
      </div> 
      </div>)}

      {signature && (
        <div>
          <p>Saved Signature:</p>
          <img src={signature} alt="signature" style={{ width: 300, height: 150, border: '1px solid #ccc' }} />
          <br />
        <Button onClick={handleClearSignature}>Clear</Button>
        </div>
      )}

      <br />
      {/* Return Inspection comment (separate from the Returned condition notes) -
          shown above the Asset Condition Report as the more logical order. */}
      {updateBooking.status === 'Return Inspection' || updateBooking.status === 'Invoiced' ? (
        <div>
          <h4>Return Inspection Notes</h4>
          <TextField
            label="Return Inspection Notes"
            name="returnInspectionNotes"
            placeholder="Return inspection notes"
            InputProps={{ readOnly: updateBooking.status === 'Invoiced' }}
            value={updateBooking.returnInspectionNotes ?? ''}
            fullWidth
            multiline
            rows={4}
            onChange={(e) => {
              setUpdateBooking({
                ...updateBooking,
                returnInspectionNotes: e.target.value,
              });
            }}
          />
        </div>
      ) : null}

      {updateBooking.status === 'Returned' || updateBooking.status === 'Invoiced' ? (
      <div>
          <h4>Asset Condition Report</h4>
          <Select style={{ padding: 0, margin: 0, maxWidth: "100%" }}
                  readOnly={updateBooking.status === 'Invoiced'}
                  name="status" value={updateBooking.assetStatus ?? "Excellent"}
                  fullWidth
                  onChange={(e) => {
                                    setUpdateBooking({
                                      ...updateBooking,
                                      assetStatus: e.target.value,
                                    });
                                  }}>
                  <MenuItem value="Excellent">Excellent</MenuItem>
                  <MenuItem value="Good">Good</MenuItem>
                  <MenuItem value="Poor">Poor</MenuItem>
                  <MenuItem value="Failed">Failed</MenuItem>
           </Select>
           <br />
           <br />

      <TextField
        label="Condition Notes"
        name="conditionNotes"
        placeholder="Condition Notes"
        InputProps={{
                    readOnly: updateBooking.status === "Invoiced",
                    }}
        value={updateBooking.assetStatusNotes ?? ''}
        fullWidth
        multiline
        rows={4}
        onChange={(e) => {
                          setUpdateBooking({
                            ...updateBooking,
                            assetStatusNotes: e.target.value,
                          });
                        }}
      />
      </div>):null}
      <br />

      <Button variant="contained" onClick={() => updateBookingAndAssets(origBooking, updateBooking, photos, signature)}>
        Update Booking
      </Button>
    </div>
  );
}

export default UpdateBookingStatus;
